import Axios from "axios";
import {
  ROOT_ADMIN,
  AGENCY_EMPLOYEE,
  AGENCY_ADMIN,
  ROOT_EMPLOYEE,
} from "../../constants/HelperConstants";
import {
  CUSTOMER_AGENCY_URL,
  PAY_PUP_LS_AUTH_USER_ROLE,
} from "../../constants/LocalStorageVariables";
import { SIGNIN_ROUTE } from "../../constants/RoutePaths";
import Swal from "sweetalert2";
import { authUserRole } from "../../functions/CoreFunctions";
const API = Axios.create({});

API.interceptors.response.use(
  (response) => {
    const { agencystatus = true } = response.headers;
    if (!agencystatus) {
      if ([ROOT_ADMIN, ROOT_EMPLOYEE].includes(authUserRole())) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "This Agency is deleted ",
          confirmButtonText:
            '<i style={{color:"white"}} class="fa fa-thumbs-up"><a href="/admin/dashboard"/></i> OkaY!',
        });
      } else if ([AGENCY_ADMIN, AGENCY_EMPLOYEE].includes(authUserRole())) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "This Agency is deleted ",
          confirmButtonText:
            '<i style={{color:"white"}} class="fa fa-thumbs-up"><a href="/agency/dashboard"/></i> OkaY!',
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "This Agency is deleted ",
          confirmButtonText:
            '<i style={{color:"white"}} class="fa fa-thumbs-up"><a href="/customer/dashboard"/></i> OkaY!',
        });
      }
    } else {
      return response;
    }
  },
  (error) => {
    const { status } = error.response;
    if (status === 401) {
      const Root = [
        ROOT_ADMIN,
        ROOT_EMPLOYEE,
        AGENCY_ADMIN,
        AGENCY_EMPLOYEE,
      ].includes(localStorage.getItem(PAY_PUP_LS_AUTH_USER_ROLE));
      const AgencyUrl = localStorage.getItem(CUSTOMER_AGENCY_URL);
      localStorage.clear();
      if (Root) {
        window.location.replace(SIGNIN_ROUTE);
      } else if (AgencyUrl) {
        window.location.replace(`/customer/${AgencyUrl}`);
      } else {
        window.location.replace(SIGNIN_ROUTE);
      }
    }
    return Promise.reject(error);
  }
);
export default API;
